<div class="!w-[100vw] flex place-content-center">
<div [class]="'animation-hide-message containter-message enter-message fixed z-50 top-[-50px] ' + customClass">
<div class="message"
    [ngClass]="{'bg-[#FA7A6A]': this.status === 'error','bg-[#9AD0D0]':this.status === 'success'}">
    <ng-content select="[message]"></ng-content>
    <div class="text-message">{{this.message}}</div>
</div>
</div></div>